(function(window, document, $, undefined){
  
// THIS IS NOW ON THE PAGE UNDER THE HEADER in page-header.php, SO THERE ISN'T A JUMP AS THE PAGE LOADS
// needs to be minified for production


  // -----------------------------------------------------------------------------------------------------
  // page header parallax
  // -----------------------------------------------------------------------------------------------------
  if($(".page-header.parallax").length){
    // // var parallaxScroll = debounce(function() {
    // //   $(".page-header.parallax").css("background-position","50% " + (50 - ($(this).scrollTop() / 20)) + "%");
    // // }, 5);
    // // var h = ($(".page-header.parallax").height())/10;
    // // var ratio = h/10; //around 1 - 10 if around 700px high.
    // var ratio = 2; //around 1 - 10 if around 700px high.
    // var parallaxScroll = function() {
    //   console.log(h*100);
    //   $(".page-header.parallax").css("background-position","50% " + (50 - ($(this).scrollTop() / ratio)) + "%");
    // };
    // $(window).on("scroll", parallaxScroll);




    // // THIS IS NOW IN PURE JS in page-header.php
    // // jquery ready fires a little later, so causes glitch
    // // purejs scroll event fires earlier, so hooking in to that instead so no glitch
    // var parallaxScroll = function() {
    //   var ratio = ($(this).scrollTop() / 2); //1 = static, >1 slower
    //   // console.log('ratio',ratio);
    //   $(".page-header.parallax .background").css("top","" + ratio + "px");
    //   $(".page-header.parallax .background").css("bottom","-" + ratio + "px");
    //   var fadeRatio = ($(this).scrollTop() / 700);// e.g. scrolled 700 down, val = 1
    //   if(fadeRatio>1) fadeRatio=1;
    //   $(".page-header.parallax .overlay").css("opacity","" + EasingFunctions.easeInQuad(fadeRatio) + "");
    // };
    // $(window).on("scroll", parallaxScroll);
    // parallaxScroll();
    
  }


  // if($(".vc_row.parallax").length){
    // var h = ($(this).height())/100;
    // var ratio = h/3;
    // var parallaxScroll = function() {
    //   $(".vc_row.parallax").css("background-position","50% " + (50 - ($(this).scrollTop() / ratio)) + "%");
    // };
    // $(window).on("scroll", parallaxScroll);
    // // parallaxScroll();
  // }

})(window, document, jQuery);



